import { FC } from "react";
import { PRIVACY_POLICY_COOKIE_KEY } from "../constants/common";

interface Props {
    setIsShow: (isShow: boolean) => void;
}

const Cookies: FC<Props> = ({ setIsShow }: Props) => {

    function setCookie(cname: string, cvalue: string, exdays: number) {

        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function hide_message() {
        setIsShow(false)
    }

    function hide_privacy_policy_message_handler() {
        hide_message();

        setCookie(PRIVACY_POLICY_COOKIE_KEY, "1", 365);

        return false;
    }

    return (
        <div id="divPrivacyPolicyMessage" className="privacy_policy_message_container">
            <div className="row">
                <div className="col-sm-11 col-xs-10">
                    <div className="privacy_policy_logo"> שים לב </div>
                    <div className="privacy_policy_message_inner_container">
                        <div className="privacy_policy_message">האתר עושה שימוש ב-cookies. כדי לספק לך חווית גלישה טובה יותר, וכן
                            למטרות סטטיסטיקה, איפיון ושיווק.</div>
                        <div className="privacy_policy_remark">למידע על cookies ועל מדיניות הפרטיות המעודכנת <a
                            href="https://www.leumi.co.il/Lobby/privacy_policy/42231/" target="_blank" rel="noreferrer"
                            aria-label="על מנת להפוך את האתר לנגיש לקורא מסך לחץ alt + 1. על מנת להפסיק הודעה זאת לחץ alt + 2.">יש
                            ללחוץ כאן</a>.
                        </div>
                    </div>
                </div>
                <div className="col-sm-1 col-xs-2">
                    <button className="privacy_policy_close_button" type="button"
                        onClick={hide_privacy_policy_message_handler} aria-label="על מנת להפוך את האתר לנגיש לקורא מסך לחץ alt + 1. על מנת להפסיק הודעה זאת לחץ alt + 2."> ×
                        <span>סגור</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
export default Cookies;